// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"efdf75cb","455":"5edfc550"}[chunkId] + ".chunk.js";
};